"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailedBasketPayment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var letstrade_new_png_1 = __importDefault(require("../../../../assets/logos/letstrade_new.png"));
var FailedBasketPayment = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var params = (0, react_router_dom_1.useParams)();
    var basketID = params.basketID, userID = params.userID, paymentIdentifier = params.paymentIdentifier;
    (0, react_1.useEffect)(function () {
        localStorage.clear();
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "container mx-auto p-4 flex flex-col gap-4 " }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "pb-18 flex justify-center" }, { children: (0, jsx_runtime_1.jsx)("img", { src: letstrade_new_png_1.default, className: "w-1/5" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-4 p-4 border border-error rounded-md" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "text-error w-10 h-10 rounded-full border border-error flex items-center justify-center" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTimes }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Payment Failed", bold: true, textColor: "text-black", size: "xlarge" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Order #".concat(basketID), size: "small" })] }))] })) })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Sorry we could process your order" })] })));
};
exports.FailedBasketPayment = FailedBasketPayment;
